import moment from 'moment';

export const getOrderStatusLabel = accountCard => {
  const status =
    accountCard?.purchased_custom_print_account_card?.pcm_order_status;
  const updatedAt =
    accountCard?.purchased_custom_print_account_card
      ?.pcm_order_status_updated_at;

  if (status === 'MAILING') {
    return 'Pending shipping';
  }

  if (status === 'DELIVERED' && updatedAt) {
    return `Shipped on: ${moment(updatedAt)
      .format('DD MMMM YYYY')
      .toUpperCase()}`;
  }

  return '';
};
